import { $findMatchingParent } from '@lexical/utils'
import { $isRootOrShadowRoot, ElementNode, TextNode } from 'lexical'

export const $getSelectedElement = (anchorNode: ElementNode | TextNode) => {
  let element =
    anchorNode.getKey() === 'root'
      ? (anchorNode as ElementNode)
      : $findMatchingParent(anchorNode, e => {
          const parent = e.getParent()
          return $isRootOrShadowRoot(parent)
        })
  if (element === null) {
    element = anchorNode.getTopLevelElementOrThrow()
  }
  return element as ElementNode
}
